<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="15"
    height="20.92"
    viewBox="0 0 15 20.92"
    class="d-flex"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_419"
          data-name="Rectangle 419"
          width="15"
          height="20.92"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Group_11190"
      data-name="Group 11190"
      transform="translate(0 -0.001)"
    >
      <g
        id="Group_11189"
        data-name="Group 11189"
        transform="translate(0 0.001)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Path_1347"
          data-name="Path 1347"
          d="M7.5,0A7.5,7.5,0,0,0,0,7.5c0,5.238,7.5,13.42,7.5,13.42S15,12.738,15,7.5A7.5,7.5,0,0,0,7.5,0m.735,13.864a1.17,1.17,0,0,1-.847.309,1.169,1.169,0,0,1-.847-.309,1.121,1.121,0,0,1,.007-1.577,1.167,1.167,0,0,1,.84-.313,1.167,1.167,0,0,1,.84.313,1.121,1.121,0,0,1,.007,1.577m2.238-6.43a4.77,4.77,0,0,1-.958,1.208L8.931,9.2A1.98,1.98,0,0,0,8.3,10.431l-.029.44H6.43a4.336,4.336,0,0,1,.245-1.609,3.3,3.3,0,0,1,.9-1.18,4.59,4.59,0,0,0,.869-.945,1.485,1.485,0,0,0,.216-.769q0-1.22-1.124-1.22a1.138,1.138,0,0,0-.854.329,1.29,1.29,0,0,0-.335.906H4.253a2.78,2.78,0,0,1,.89-2.157,3.466,3.466,0,0,1,2.389-.779A3.481,3.481,0,0,1,9.9,4.187a2.631,2.631,0,0,1,.843,2.089,2.543,2.543,0,0,1-.274,1.158"
          transform="translate(0 0)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LegendIcon',
};
</script>
